module.exports = __webpack_public_path__ + "img/GetBoarded_Logo2.d71ce924.svg";